import React, { FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './font-size.module.scss'

export const Header2: FC<HTMLAttributes<HTMLHeadingElement>> = ({
  className,
  children,
  ...rest
}) => (
  <h2 className={cn(classes.header2, className)} {...rest}>
    {children}
  </h2>
)
